import React from 'react';
import { Helmet } from 'react-helmet-async';
import { SITE_BRAND, canonicalUrl, defaultOgImage } from '../constants/site';

export function Seo({ title, description, path = '/', noindex = false, ogImage }) {
  const canonical = canonicalUrl(path);
  const fullTitle = title ? `${title} | ${SITE_BRAND}` : `${SITE_BRAND} | Klimatizacija, grejanje, ventilacija`;
  const image = ogImage || defaultOgImage();
  const imageAlt = `${SITE_BRAND} logo`;

  return (
    <Helmet htmlAttributes={{ lang: 'sr' }}>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />

      {noindex && <meta name="robots" content="noindex, nofollow" />}

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_BRAND} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />
      <meta property="og:image:secure_url" content={image} />
      <meta property="og:image:alt" content={imageAlt} />
      <meta property="og:image:type" content="image/jpeg" />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:locale" content="sr_RS" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:image:alt" content={imageAlt} />
    </Helmet>
  );
}
